import { render, staticRenderFns } from "./PageDoctorNotice.vue?vue&type=template&id=4dec19a8&scoped=true"
import script from "./PageDoctorNotice.vue?vue&type=script&lang=js"
export * from "./PageDoctorNotice.vue?vue&type=script&lang=js"
import style0 from "./PageDoctorNotice.vue?vue&type=style&index=0&id=4dec19a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dec19a8",
  null
  
)

export default component.exports